// extracted by mini-css-extract-plugin
export default {"commentCount":"CommentCount-module__commentCount_yK27P","icon":"CommentCount-module__icon_Fmmy1"};